// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__NPSb4","collapse":"styles_collapse__3trPw"};